import React from 'react';
import './styles.css';

// Base StatusChip component
const StatusChip = ({ text, variant = 'default', className = '' }) => {
  return (
    <span className={`status-chip ${variant} ${className}`}>
      {text}
    </span>
  );
};

// Main status variants
StatusChip.Success = ({ text, className = '' }) => (
  <StatusChip text={text} variant="success" className={className} />
);

StatusChip.Error = ({ text, className = '' }) => (
  <StatusChip text={text} variant="error" className={className} />
);

StatusChip.Default = ({ text, className = '' }) => (
  <StatusChip text={text} variant="default" className={className} />
);

StatusChip.Alert = ({ text, className = '' }) => (
  <StatusChip text={text} variant="alert" className={className} />
);

StatusChip.Info = ({ text, className = '' }) => (
  <StatusChip text={text} variant="info" className={className} />
);

export default StatusChip;